<template>
  <div id="i_order">
    <h4
      v-if="NewIDentity == 2"
      class="mb-3 word-bold"
    >
      <font-awesome-icon
        icon="list-ul"
        class="mr-1"
      />
      教務證件申請
    </h4>
    <hr v-if="NewIDentity == 2">
    <!-- 項目Tab -->
    <ul
      id="inquire_Tab"
      class="nav nav-tabs"
      role="tablist"
    >
      <li class="nav-item">
        <a
          v-if="NewIDentity == 1"
          id="i_document_tab"
          class="nav-link"
          href="#/inquire/document"
          role="tab"
          aria-controls="i_document_list"
          aria-selected="false"
        >
          證件申請
        </a>
      </li>
      <li class="nav-item">
        <a
          v-if="NewIDentity == 1"
          id="i_checkout_tab"
          class="nav-link"
          href="#/inquire/checkout"
          role="tab"
          aria-controls="i_checkout_list"
          aria-selected="false"
        >
          費用結算
        </a>
      </li>
      <li class="nav-item">
        <a
          v-if="NewIDentity == 1"
          id="i_order_tab"
          class="nav-link active"
          href="#/inquire/order"
          role="tab"
          aria-controls="i_order_list"
          aria-selected="true"
        >
          訂單查詢
        </a>
        <a
          v-if="NewIDentity == 2"
          id="i_order_tab"
          class="nav-link active"
          href="#/admin/order"
          role="tab"
          aria-controls="i_order_list"
          aria-selected="true"
        >
          訂單查詢
        </a>
      </li>
    </ul>
    <!-- 訂單查詢 -->
    <div
      id="i_order_list"
      class="tab-pane fade show content-color"
      role="tabpanel"
      aria-labelledby="i_order_tab"
    >
      <div class="col-12 pt-3 table-style">
        <div class="form-group row">
          <div class="col-md-4">
            <label>
              查詢結帳日期(起始)：
            </label>
            <a-locale-provider
              class="dddd"
              :locale="zhTW"
            >
              <a-date-picker
                size="large"
                @change="onChange"
                :format="dateFormat"
                v-model="timeChkStartTime"
              />
            </a-locale-provider>
          </div>
          <div class="col-md-4">
            <label>查詢結帳日期(結束)：</label>
            <a-locale-provider
              class="dddd"
              :locale="zhTW"
            >
              <a-date-picker
                size="large"
                @change="onChanges"
                :format="dateFormat"
                v-model="timeChkEndTime"
              />
            </a-locale-provider>
          </div>
          <div
            class="col-md-4"
            v-if="NewIDentity == 2"
          >
            <label>查詢繳款人：</label>
            <input
              type="text"
              class="input-style qnm"
              v-model="Query.PaymentName"
            >
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label for="query-orderno">
              查詢訂單：
            </label>
            <input
              id="query-orderno"
              type="text"
              class="input-style qon"
              placeholder="請輸入訂單編號"
              v-model="Query.OrderNo"
            >
          </div>
          <div class="col-md-3">
            <label>選擇繳費狀態：</label>
            <select
              class="input-style qdg"
              v-model="Query.OrderStatus"
            >
              <option
                v-for="selectStatu in selectStatus"
                :key="selectStatu.id"
                :value="selectStatu.value"
              >
                {{ selectStatu.text }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <button
              type="button"
              class="btn btn-outline-primary ml-2 ssss"
              @click="PostQueryData"
            >
              查詢
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary ml-2 ssss"
              @click="ClearCondition"
            >
              清除
            </button>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label>筆數：</label>
            <select
              class="input-style qpg"
              v-model="perPage"
              :options="pageOptions"
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
          </div>
        </div>
        <hr>
        <!-- 訂單資料表格 -->
        <div class="row px-3">
          <template>
            <b-table
              hover
              small
              bordered
              show-empty
              stacked="md"
              empty-text="目前無資料"
              class="table-break"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <!-- 繳費狀態 -->
              <template v-slot:cell(OrderStatus)="data">
                <div
                  v-for="(value, key) in selectStatus"
                  :key="key"
                  class="dc dbd"
                >
                  <span v-if="value.value == data.item.OrderStatus">
                    {{ value.text }}
                  </span>
                </div>
              </template>
              <template v-slot:cell(PaymentName)="data">
                {{ data.item.PaymentName }}<br>
                {{ data.item.RealName }}
              </template>
              <template v-slot:cell(DocTotalAmt)="data">
                {{ data.item.DocTotalAmt + ' 元' }}
              </template>
              <template v-slot:cell(PostageAmt)="data">
                {{ data.item.PostageAmt + ' 元' }}
              </template>
              <template v-slot:cell(TotalAmt)="data">
                <div class="dc dbd">
                  {{ data.item.TotalAmt + ' 元' }}
                </div>
              </template>
              <!-- 展開 -->
              <template v-slot:cell(Action)="data">
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="info"
                  @click.native="data.toggleDetails"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="level-down-alt"
                  />
                  <span
                    slot="icon"
                    class="ml-1"
                  >
                    {{ data.detailsShowing ? ' 關閉訂單' : ' 展開訂單' }}
                  </span>
                </v-button>
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="primary"
                  data-toggle="modal"
                  data-target="#EditMailNo"
                  v-if="NewIDentity == 2 && data.item.OrderStatus >= 3"
                  @click.native="ShowOrderMailNo(data.item)"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="edit"
                  />
                  <span slot="icon">
                    {{ '郵件號碼' }}
                  </span>
                </v-button>
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="warning"
                  v-if="NewIDentity == 2 && data.item.OrderStatus >= 3"
                  @click.native="PostOrderPrintAll(data.item)"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="print"
                  />
                  <span slot="icon">
                    {{ '全部列印' }}
                  </span>
                </v-button>
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="warning"
                  v-if="NewIDentity == 2 && data.item.OrderStatus >= 3"
                  @click.native="PrintFC(data.item.PaymentName,data.item.PostMethod)"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="envelope"
                  />
                  <span slot="icon">
                    {{ '列印封面' }}
                  </span>
                </v-button>
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="danger"
                  data-toggle="modal"
                  data-target="#DeleCheckout"
                  v-if="NewIDentity == 1 && data.item.OrderStatus <= 2"
                  @click.native="ShowDelOrderData(data.item.OrderNo)"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="times"
                  />
                  <span slot="icon">
                    {{ '刪除' }}
                  </span>
                </v-button>
                <v-button
                  class="mr-1"
                  btn-size="sm"
                  btn-type="primary"
                  @click.native="EditRemarkForSealData(data.item.RemarkForSeal)"
                  v-if="data.item.RemarkForSeal"
                >
                  <font-awesome-icon
                    slot="eg"
                    icon="edit"
                  />
                  <span slot="icon">
                    {{ '訂單備註' }}
                  </span>
                </v-button>
              </template>
              <template v-slot:row-details="row">
                <!-- 詳細資料，span_id"mydesc"因指引視障使用規則，須顯示table的文字敘述，但我span裡目前沒加table文字敘述...很醜 -->
                <span id="mydesc" />
                <table
                  aria-describedby="mydesc"
                  class="table table-bordered table-hover table-responsive"
                  style="font-size:16px; width:100%"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th id="index">
                        #
                      </th>
                      <th id="DocName">
                        繳款項目
                      </th>
                      <th id="SchoolYear">
                        學年
                      </th>
                      <th id="Semester">
                        學期
                      </th>
                      <th id="DocCnt">
                        數量
                      </th>
                      <th id="DocAmt">
                        證件金額
                      </th>
                      <th id="Remark">
                        備註
                      </th>
                      <th
                        id="Action"
                        v-if="NewIDentity == 2"
                      >
                        功能
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(value, key) in row.item.DocList"
                    :key="key"
                  >
                    <tr>
                      <td>{{ key + 1 }}</td>
                      <td>{{ value.DocName }}</td>
                      <td>{{ value.SchoolYear }}</td>
                      <td>{{ value.Semester }}</td>
                      <td>{{ value.DocCnt }}</td>
                      <td>{{ value.DocAmt + ' 元' }}</td>
                      <td>{{ value.Remark }}</td>
                      <td v-if="NewIDentity == 2">
                        <v-button
                          class="mr-1"
                          btn-size="sm"
                          btn-type="primary"
                          title="編輯備註"
                          @click.native="(EditRemark.OrderNo = row.item.OrderNo),(NewRemark = value.Remark),EditRemarkData(value)"
                        >
                          <font-awesome-icon
                            slot="eg"
                            icon="edit"
                          />
                          <span slot="icon">
                            {{ '編輯' }}
                          </span>
                        </v-button>
                        <v-button
                          class="mr-1"
                          btn-size="sm"
                          btn-type="warning"
                          v-if="value.IsPrint === 1 && row.item.OrderStatus >= 3"
                          @click.native="(NewOrderNo = row.item.OrderNo),PostOrderPrint(value)"
                        >
                          <font-awesome-icon
                            slot="eg"
                            icon="edit"
                          />
                          <span slot="icon">
                            {{ '列印' }}
                          </span>
                        </v-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="public-table"
              class="my-0"
            />
          </template>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>
    <!-- Modal 輸入郵件號碼 -->
    <div
      id="EditMailNo"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="EditMailNoTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              class="modal-title"
              id="EditMailNoTitle"
            >
              輸入郵件號碼
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            <!-- 郵件號碼 -->
            <div class="form-group">
              <label
                for="MailNo"
                class="col-form-label"
              >
                郵件號碼:
              </label>
              <input
                id="MailNo"
                class="form-control"
                type="text"
                v-model="AddMailNo"
              >
            </div>
            <hr>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary ml-2"
              @click="PostOrderMailNo"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal 編輯備註 -->
    <div
      id="I_EditCenter"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="I_EditCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              class="modal-title"
              id="I_EditLongTitle"
            >
              編輯訂單備註
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            <!-- 備註 -->
            <div class="form-group">
              <label
                for="modify"
                class="col-form-label"
              >
                備註:
              </label>
              <textarea
                id="modify"
                class="form-control"
                v-model="NewRemark"
              />
            </div>
            <hr>
            <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="PostOrderRemark"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal 刪除訂單 -->
    <div
      id="DeleCheckout"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="DeleCheckoutCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="Checkout"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              id="DeleCheckoutLongTitle"
              class="modal-title"
            >
              刪除訂單項目
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            確認是否刪除「{{ this.NewOrderNo }}」訂單?
            <br><hr>
            <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="DelOrderData"
            >
              刪除
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal 彌封備註 -->
    <div
      id="I_RemarkForSeal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="I_RemarkForSealTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              class="modal-title"
              id="I_RemarkForSealTitle"
            >
              訂單備註
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            <!-- 備註 -->
            <div class="form-group">
              {{ RemarkForSeal }}
            </div>
            <hr>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiOrderQuery, apiOrderModify, apiOrderMailnoadd, apiOrderPrintall, apiOrderPrint, apiOrderDelete } from '../../apis/api.config.js'
import md5 from 'js-md5'
import $ from 'jquery'
import moment from 'moment'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
window.addEventListener('DOMContentLoaded', function () {
  var Vue = window.Vue
  var VueBarcode = window.VueBarcode
  Vue.component('barcode', VueBarcode)
  let vm = new Vue({
    el: '#i_order'
  })
  Vue.use({
    vm
  })
})
export default {
  data () {
    return {
      items: [],
      fields: [
        { key: 'index', label: '#', thClass: 'table-th tab_a', sortDirection: 'desc', variant: 'info' },
        { key: 'OrderNo', label: '訂單編號', thClass: 'table-th', sortable: true },
        { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th', sortable: true },
        { key: 'CheckOutDate', label: '訂單建立日期', thClass: 'table-th tab_b', sortable: true },
        { key: 'PaymentName', label: '繳款人', thClass: 'table-th tab_c' },
        { key: 'OrderStatus', label: '繳費狀態', thClass: 'table-th tab_d', sortable: true, variant: 'warning' },
        { key: 'PaymentDate', label: '繳款日期', thClass: 'table-th tab_e', sortable: true },
        { key: 'MailNo', label: '郵件號碼', thClass: 'table-th' },
        { key: 'DocTotalAmt', label: '證件金額(a)', thClass: 'table-th' },
        { key: 'PostageAmt', label: '郵件金額(b)', thClass: 'table-th' },
        { key: 'TotalAmt', label: '總金額(a+b)', thClass: 'table-th tab_f', variant: 'warning', sortable: true },
        { key: 'Action', label: '功能', thClass: 'table-th tab_g' }
      ],
      selectStatus: [
        { text: '-請選擇-', value: null },
        { text: '已結帳', value: 2 },
        { text: '已繳費', value: 3 },
        { text: '已寄出', value: 4 }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      AddMailNo: '',
      EditRemark: {},
      NewOrderNo: '',
      MailOrderNo: '',
      NewRemark: '',
      NewIDentity: null,
      Query: {
        OrderNo: null,
        ChkStartTime: null,
        ChkEndTime: null,
        OrderStatus: null,
        PaymentName: null
      },
      UserData: false,
      timeChkStartTime: undefined,
      timeChkEndTime: undefined,
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      RemarkForSeal: ''
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () {
    this.onMounted()
  },
  methods: {
    moment,
    async onMounted () {
      await this.IDIF()
      if (sessionStorage.getItem('SearchData')) {
        const SearchData = JSON.parse(sessionStorage.getItem('SearchData'))
        this.Query = SearchData.Query
        if (SearchData.timeChkStartTime) {
          SearchData.timeChkStartTime = moment(SearchData.timeChkStartTime._d)
        }
        if (SearchData.timeChkEndTime) {
          SearchData.timeChkEndTime = moment(SearchData.timeChkEndTime._d)
        }
        this.timeChkStartTime = SearchData.timeChkStartTime
        this.timeChkEndTime = SearchData.timeChkEndTime
        await this.PostQueryData()
        sessionStorage.removeItem('SearchData')
      }
    },
    onChange (date, dateString) { // 結帳日期(起始)
      this.timeChkStartTime = date
      this.Query.ChkStartTime = dateString
    },
    onChanges (date, dateString) { // 結帳日期(結束)
      this.timeChkEndTime = date
      this.Query.ChkEndTime = dateString
    },
    IDIF () { // 帳號身分驗證
      const vm = this
      // 確認登入、權限
      if (localStorage.getItem('A_Privilege') === md5('教務_一般使用者')) {
        vm.UserData = JSON.parse(localStorage.getItem('A_Identity'))
        vm.NewIDentity = 1
      } else if (localStorage.getItem('A_Privilege') === md5('教務_管理者')) {
        vm.UserData = JSON.parse(sessionStorage.getItem('A_Identity'))
        vm.NewIDentity = 2
      } else {
        return false
      }
      if (!vm.UserData) {
        vm.ErrorModal('請登入。')
        vm.$bus.$emit('MenuLoginOut', 'false')
        return false
      }
    },
    info (item, index, button) { // 展開表格
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    PostQueryData () { // API_007 訂單查詢
      // 定義資料
      const vm = this
      const NewData = Object.assign(vm.Query, vm.UserData)
      const StudentData = JSON.parse(localStorage.getItem('A_StudentData'))
      NewData.OrderType = 2 // 訂單種類:1未結帳，2已結帳
      if (vm.NewIDentity === 1) {
        NewData.StudentId = StudentData.StudentId
      }
      vm.$bus.$emit('Loading', true)
      // 呼叫API
      apiOrderQuery(NewData).then(
        res => {
          console.log(res.data)
          vm.$bus.$emit('Loading', false)
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              if (vm.NewIDentity === 2) {
                vm.fields = [
                  { key: 'index', label: '#', thClass: 'table-th tab_a', sortDirection: 'desc', variant: 'info' },
                  { key: 'OrderNo', label: '訂單編號', thClass: 'table-th', sortable: true },
                  { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th', sortable: true },
                  { key: 'CheckOutDate', label: '訂單建立日期', thClass: 'table-th tab_b', sortable: true },
                  { key: 'PaymentName', label: '繳款人', thClass: 'table-th tab_c' },
                  { key: 'PostMethod', label: '郵寄方式', thClass: 'table-th tab_fb', variant: 'warning', sortable: true },
                  { key: 'OrderStatus', label: '繳費狀態', thClass: 'table-th tab_d', sortable: true, variant: 'warning' },
                  { key: 'PaymentDate', label: '繳款日期', thClass: 'table-th tab_e', sortable: true },
                  { key: 'MailNo', label: '郵件號碼', thClass: 'table-th' },
                  { key: 'DocTotalAmt', label: '證件金額(a)', thClass: 'table-th' },
                  { key: 'PostageAmt', label: '郵件金額(b)', thClass: 'table-th' },
                  { key: 'TotalAmt', label: '總金額(a+b)', thClass: 'table-th tab_f', variant: 'warning', sortable: true },
                  { key: 'Action', label: '功能', thClass: 'table-th tab_g' }
                ]
              }
              for (let i = 0; i < res.data.Data.length; i++) {
                const json = res.data.Data[i]
                json.index = i + 1
              }
              vm.items = res.data.Data
              vm.totalRows = vm.items.length
              if (sessionStorage.getItem('pageData')) {
                const pageData = JSON.parse(sessionStorage.getItem('pageData'))
                this.perPage = pageData.perPage
                this.$nextTick(function () {
                  this.currentPage = pageData.currentPage
                })
                sessionStorage.removeItem('pageData')
              }
            } else {
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.ErrorModal(res.data.Msg)
          }
        }
      )
    },
    EditRemarkForSealData (data) { // 訂單彌封備註
      $('#I_RemarkForSeal').modal('show')
      const vm = this
      vm.RemarkForSeal = data
    },
    EditRemarkData (data) { // 準備 API 009 編輯備註
      $('#I_EditCenter').modal('show')
      const vm = this
      vm.EditRemark.DocId = data.DocId
      vm.EditRemark.SchoolYear = data.SchoolYear
      vm.EditRemark.Semester = data.Semester
    },
    PostOrderRemark () { // API 009 編輯備註
      // 定義資料
      const vm = this
      const Identity = JSON.parse(sessionStorage.getItem('A_Identity'))
      const NewData = Object.assign(Identity, vm.EditRemark)
      $('#I_EditCenter').modal('hide')
      NewData.Remark = vm.NewRemark
      vm.$bus.$emit('Loading', true)
      if (NewData.SchoolYear === '') {
        NewData.SchoolYear = 0
      }
      if (NewData.Semester === '') {
        NewData.Semester = 0
      }
      // 呼叫API
      apiOrderModify(NewData).then(
        res => {
          vm.$bus.$emit('Loading', false)
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              vm.$bus.$emit('Modals', '修改成功。')
              $('#CheckOk').modal('show')
              // 刷新資料
              vm.PostQueryData()
            } else {
              vm.NewRemark = ''
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.NewRemark = ''
            vm.ErrorModal(res.data.Msg)
          }
        }
      )
    },
    ShowOrderMailNo (data) { // 準備輸入郵件編號 API 011
      this.MailOrderNo = data.OrderNo
    },
    PostOrderMailNo () { // API 011 輸入郵件編號
      // 定義資料
      const vm = this
      vm.$bus.$emit('Loading', true)
      $('#EditMailNo').modal('hide')
      if (vm.AddMailNo !== '') {
        const NewData = JSON.parse(sessionStorage.getItem('A_Identity'))
        NewData.OrderNo = vm.MailOrderNo
        NewData.MailNo = vm.AddMailNo
        // 呼叫API
        apiOrderMailnoadd(NewData).then(
          res => {
            vm.$bus.$emit('Loading', false)
            if (res.status === 200) {
              if (res.data.ErrorCode === 0) {
                vm.$bus.$emit('Modals', '修改成功。')
                $('#CheckOk').modal('show')
                // 刷新資料
                vm.PostQueryData()
              } else {
                vm.AddMailNo = ''
                vm.ErrorModal(res.data.Msg)
              }
            } else {
              vm.AddMailNo = ''
              vm.ErrorModal(res.data.Msg)
            }
          }
        )
      }
    },
    PostOrderPrintAll (data) { // API 014 全部列印
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('A_Identity'))
      vm.$bus.$emit('Loading', true)
      NewData.OrderNo = data.OrderNo
      // 呼叫API
      apiOrderPrintall(NewData).then(
        res => {
          vm.$bus.$emit('Loading', false)
          if (res.data.ErrorCode === 0) {
            vm.$bus.$emit('Modals', res.data.Msg)
            $('#CheckOk').modal('show')
            return false
          } else {
            vm.$bus.$emit('Modals', res.data.Msg)
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostOrderPrint (data) { // API 015 單筆列印
      // 定義資料
      const vm = this
      vm.$bus.$emit('Loading', true)
      const NewData = JSON.parse(sessionStorage.getItem('A_Identity'))
      NewData.OrderNo = this.NewOrderNo
      NewData.DocId = data.DocId
      NewData.SchoolYear = data.SchoolYear
      NewData.Semester = data.Semester
      // 呼叫API
      apiOrderPrint(NewData).then(
        res => {
          vm.$bus.$emit('Loading', false)
          if (res.data.ErrorCode === 0) {
            vm.$bus.$emit('Modals', res.data.Msg)
            $('#CheckOk').modal('show')
            return false
          } else {
            vm.$bus.$emit('Modals', res.data.Msg)
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ShowDelOrderData (data) { // 準備刪除訂單 API 012
      this.NewOrderNo = data
    },
    DelOrderData () { // API 012 訂單刪除
      // 定義資料
      const vm = this
      $('#DeleCheckout').modal('hide')
      vm.$bus.$emit('Loading', true)
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      NewData.OrderNo = vm.NewOrderNo
      // 呼叫API
      apiOrderDelete(NewData).then(
        res => {
          vm.$bus.$emit('Loading', false)
          vm.NewOrderNo = null
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              vm.$bus.$emit('Modals', '訂單刪除成功。')
              $('#CheckOk').modal('show')
              // 刷新資料
            } else {
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.ErrorModal(res.data.Msg)
          }
        }
      )
    },
    PrintFC (data, sendType) { // 導向列印封面
      const vm = this
      let SearchData = {
        Query: vm.Query,
        timeChkStartTime: vm.timeChkStartTime ? { ...vm.timeChkStartTime } : undefined,
        timeChkEndTime: vm.timeChkEndTime ? { ...vm.timeChkEndTime } : undefined
      }
      sessionStorage.setItem('SendType', sendType)
      sessionStorage.setItem('SearchData', JSON.stringify(SearchData))
      let pageData = {
        perPage: vm.perPage,
        currentPage: vm.currentPage
      }
      sessionStorage.setItem('pageData', JSON.stringify(pageData))
      this.$router.push({ name: 'a_FrontCover', params: { uid: data } })
    },
    ClearCondition () { // 清除資料
      const vm = this
      vm.Query = {
        OrderNo: null,
        ChkStartTime: null,
        ChkEndTime: null,
        OrderStatus: null,
        PaymentName: null
      }
      vm.items = []
      vm.timeChkStartTime = undefined
      vm.timeChkEndTime = undefined
      vm.IDIF()
    },
    ErrorModal (data) {
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>
<style lang="scss">

.tab_g {
  width: 205px;
}
.tab_fb {
  width: 6rem;
}
.qon {
  margin-left: 4.7rem !important;
}
.qnm {
  margin-left: 3.7rem !important;
}
.qpg {
  margin-left: 6.7rem !important;
}
.qdg {
  margin-left: 2.7rem !important;
}

@media only screen and (max-width:1225px) {
  .qon {
    margin-left: 0rem !important;
  }
  .qnm {
    margin-left: 0em !important;
  }
  .qpg {
    margin-left: 0rem !important;
  }
  .qdg {
  margin-left: 0rem !important;
}
}
</style>
